import axios from 'axios'

export const verifyCustomers = companyIds => {
    return axios.post('/ajax/verify-multiple-customers', {
        sapIds: companyIds,
    })
}
export const verifyCustomer = sapId => {
    return axios.post('/ajax/verify-customer', { sapId })
}
export const sendInvite = userId => {
    return axios.post('/ajax/send-invite', { userId })
}
export const selfActivationInvite = userId => {
    return axios.post('/ajax/send-self-activation-invite', { userId })
}
export const changeSalesPersonStatus = data => {
    return axios.put('/ajax/admins/status', data)
}
export const deleteAdmin = userId => {
    return axios.post('/ajax/delete-admin', { userId })
}
export const toggleFeature = feature => {
    return axios.post('/ajax/toggle-feature', { feature })
}
export const getFeatureFlags = () => {
    return axios.get('/ajax/feature-flags')
}
export const getReportUsersInfo = () => {
    return axios.get('/ajax/users-report')
}
export const getReportUsersLoginInfo = () => {
    return axios.get('/ajax/login-users-report')
}
export const getReportSalesRepLoginInfo = () => {
    return axios.get('/ajax/login-sales-rep-report')
}
export const searchUserAndCompanies = query => {
    return axios.get('/ajax/usersAndCompanies', {
        params: {
            query,
        },
    })
}
export const getUsers = params => {
    return axios.get('/ajax/users', {
        params,
    })
}
export const refreshCompanyData = data => {
    return axios.post('/ajax/refresh-data', data)
}
export const deleteUser = data => {
    return axios.post('/ajax/delete-user', data)
}
export const deleteCompany = data => {
    return axios.post('/ajax/delete-company', data)
}
export const changeMaintenanceMode = () => {
    return axios.post('/ajax/maintenance-mode')
}
export const updateMaintenanceModeData = data => {
    return axios.post('/ajax/maintenance-mode-data', data)
}
export const listCompanies = () => {
    return axios.get('/ajax/companies')
}
export const updateUser = userId => {
    return axios.post('/ajax/update-management', { userId })
}
export const impersonateUser = userId => {
    return axios.post('/ajax/impersonate', { userId })
}
export const stopImpersonation = impersonatedId => {
    const payload =
        impersonatedId !== undefined &&
        impersonatedId !== null &&
        impersonatedId !== ''
            ? { impersonatedId }
            : {}
    return axios.post('/ajax/stop-impersonation', payload)
}
